import React, { useEffect, useState } from 'react';

import { t } from 'i18next';
import { useFormik } from 'formik';

import Yup from '../../../../utils/yupExtensions';
import styles from './EmployerPortalJobs.module.css';
import { filterUI } from './FilterUI';
import { JobListUI } from './JobListUI';
import { tableHeaderUI } from './TableHeader';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

function EmployerPortalJobs({ setPostJobEnable, jobs, setSelectedJobsForDetail, showUpgradeModal }) {
    const [activeButton, setActiveButton] = useState(t('filterButtons.all'));
    const [selectAll, setSelectAll] = useState(false);
    const [selectedJobs, setSelectedJobs] = useState([]);
    const [jobsClone, setjobsClone] = useState([]);
    const [isDropdownEnabled, setIsDropdownEnabled] = useState(-1);
    const [sortOrder, setSortOrder] = useState('newest');
    const [isLoading, setIsLoading] = useState(true);
    const features = useSelector(state => state.user.features);

    const navigate = useNavigate();

    const handleToggleDropdown = (index) => setIsDropdownEnabled(index);
    const handleDropdownClose = () => setIsDropdownEnabled(-1);

    const handlePostJob = () => {
        setPostJobEnable(true);
    };

    const sortJobs = (jobs, order) => {
        if (!jobs || !Array.isArray(jobs)) return [];
         
        return [...jobs].sort((a, b) => {
            const dateA = new Date(a.createdAt || a.date_posted || 0);
            const dateB = new Date(b.createdAt || b.date_posted || 0);
            return order === 'newest' ? dateB - dateA : dateA - dateB;
        });
    };

    const getNumberOfJobs = (index) => {
        if (index == 0) return (jobs?.total || 0)
        else if (index == 1) return (jobs?.active || 0)
        else if (index == 2) return (jobs?.paused || 0)
        else if (index == 3) return (jobs?.closed || 0)
    }

    const formik = useFormik({
        initialValues: { title: '', },
        validationSchema: Yup.object({}),
        onSubmit: async (values) => { },
    });

    const handleSelectAll = () => {
        setSelectAll(!selectAll);
        if (!selectAll) { setSelectedJobs(jobs?.jobs?.map(job => job.id)); }
        else { setSelectedJobs([]); }
    };

    const handleJobSelect = (jobId) => {
        handleDropdownClose()
        navigate(`/employer-portal/${jobId}`);
        if (selectedJobs.includes(jobId)) { setSelectedJobs(selectedJobs.filter(id => id !== jobId)); }
        else { setSelectedJobs([...selectedJobs, jobId]); }
    };

    const handleJobSelectForDetail = (jobId, viewJob) => {
        if (isDropdownEnabled !== -1) {
            handleDropdownClose()
            if (viewJob) {
                setSelectedJobsForDetail(jobId)
            }
        } else {
            handleJobSelect(jobId)
            setSelectedJobsForDetail(jobId)
        }
    };

    const tableHeader = [
        '',
        t('tableHeaders.jobTitle'),
        t('tableHeaders.applicants'),
        t('tableHeaders.datePosted'),
        t('tableHeaders.jobStatus'),
        ''
    ];
    
    useEffect(() => {
        let filteredJobs = [];
        if (!jobs?.jobs) {
            setIsLoading(true);
            return;
        }
        
        if (activeButton == t('filterButtons.all')) filteredJobs = jobs?.jobs;
        else if (activeButton == t('filterButtons.open')) filteredJobs = jobs?.jobs?.filter((e) => e.status == 'active');
        else if (activeButton == t('filterButtons.paused')) filteredJobs = jobs?.jobs?.filter((e) => e.status == 'paused');
        else if (activeButton == t('filterButtons.closed')) filteredJobs = jobs?.jobs?.filter((e) => e.status == 'closed');
        
        const sortedJobs = sortJobs(filteredJobs, sortOrder);
        setjobsClone(sortedJobs);
        setIsLoading(false);
    }, [jobs?.jobs, activeButton, sortOrder]);
    
    useEffect(() => {
        if (!jobs?.jobs) {
            setIsLoading(true);
            return;
        }
        
        if (formik.values.title) {
            // Check if title is an array of selected job IDs
            if (Array.isArray(formik.values.title) && formik.values.title.length > 0) {
                // Extract the job IDs from the selected options
                const selectedJobIds = formik.values.title.map(item => item.value);
                // Filter jobs where the ID matches any of the selected IDs
                const filteredByIds = jobs?.jobs?.filter(job => selectedJobIds.includes(job.id));
                setjobsClone(sortJobs(filteredByIds, sortOrder));
            } else if (typeof formik.values.title === 'string' && formik.values.title.length > 0) {
                // Fall back to original text-based filtering
                const filteredByTitle = jobs?.jobs?.filter((e) => e.title.includes(formik.values.title));
                setjobsClone(sortJobs(filteredByTitle, sortOrder));
            } else {
                // No title filter applied
                let filteredJobs = [];
                if (activeButton == t('filterButtons.all')) filteredJobs = jobs?.jobs;
                else if (activeButton == t('filterButtons.open')) filteredJobs = jobs?.jobs?.filter((e) => e.status == 'active');
                else if (activeButton == t('filterButtons.paused')) filteredJobs = jobs?.jobs?.filter((e) => e.status == 'paused');
                else if (activeButton == t('filterButtons.closed')) filteredJobs = jobs?.jobs?.filter((e) => e.status == 'closed');
                
                setjobsClone(sortJobs(filteredJobs, sortOrder));
            }
        } else {
            let filteredJobs = [];
            if (activeButton == t('filterButtons.all')) filteredJobs = jobs?.jobs;
            else if (activeButton == t('filterButtons.open')) filteredJobs = jobs?.jobs?.filter((e) => e.status == 'active');
            else if (activeButton == t('filterButtons.paused')) filteredJobs = jobs?.jobs?.filter((e) => e.status == 'paused');
            else if (activeButton == t('filterButtons.closed')) filteredJobs = jobs?.jobs?.filter((e) => e.status == 'closed');
            
            setjobsClone(sortJobs(filteredJobs, sortOrder));
        }
        setIsLoading(false);
    }, [formik.values.title]);

    return (
        <div>
            {filterUI(
                handlePostJob, 
                setActiveButton, 
                formik, 
                activeButton, 
                getNumberOfJobs, 
                sortOrder, 
                setSortOrder
            )}

            <div className={`${styles.row} ${styles.tableHeader}`}>
                {tableHeader.map((item, index) => tableHeaderUI(item, index, tableHeader, selectAll, handleSelectAll))}
            </div>

            <div className={styles.scrollContainer}>
                {isLoading ? (
                    <div className={styles.loaderContainer}>
                        <div className={styles.loader}></div>
                        <p>{t('forms.login.processing')}</p>
                    </div>
                ) : (
                    jobsClone?.length > 0 && jobsClone?.map((item, index) => {
                        return (
                            <JobListUI
                                key={item.id || index}
                                item={item}
                                index={index}
                                handleJobSelect={handleJobSelect}
                                handleDropdownClose={handleDropdownClose}
                                handleJobSelectForDetail={handleJobSelectForDetail}
                                isDropdownEnabled={isDropdownEnabled}
                                handleToggleDropdown={handleToggleDropdown}
                                selectedJobs={selectedJobs}
                                jobs={jobs}
                            />
                        )
                    })
                )}
            </div>
        </div>
    );
}

export default EmployerPortalJobs;